export class GetBO {
    orderColumn: string;
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    listId: string;
    field: string;
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    type: string = "string";
    employeeId: string;
    clientId: string;
    masterServiceId: string;
    clientAuthId: string;
    hours: number;
    payRate: number;
    totalAmount: number;
    timesheetDate: string;
    timesheetNotes: string;
    start: string | null;
    end: string | null;
    employee: string | null;
    payor: string | null;
    service: string | null;
    agencyId: string;
    locationId: string | null;
    client: string | null;

}